import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';

import { MasterclassService } from './masterclass.service';

/**
 * Guard for masterclass accessibility
 */
export const masterclassAccessibleGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const masterclassService = inject(MasterclassService);

  const masterclassId = Number(route.paramMap.get('id'));

  const isMasterclassAccessible = await lastValueFrom(masterclassService.isMasterclassAccesible(masterclassId));
  if (!isMasterclassAccessible) {
    return router.parseUrl('overview');
  }

  return true;
};
